var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "17", height: "17", viewBox: "0 0 17 17", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "cancel"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
      React.createElement("circle", { cx: "8.5", cy: "8.5", r: "7.5" }),
      React.createElement("path", { d: "M3.197 13.803L13.803 3.197" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/cancel.svg